import { useQuery } from '@tanstack/react-query';

import { getConfiguration } from '../queries/getConfiguration.ts';
import { getTerritories, getTerritory } from '../queries/getTerritories.ts';
import { Territory } from '../schema/Territory.ts';

export const useAllTerritories = () => {
  return useQuery({
    queryKey: ['territories'],
    queryFn: ({ signal }) => getTerritories(signal),
    retry: false,
    select: territory => territory?.sort((a: Territory, b: Territory) => a.slug.localeCompare(b.slug)),
  });
};

export const useTerritory = (territorySlug: string) => {
  return useQuery({
    queryKey: ['territory', territorySlug],
    queryFn: ({ signal }) => getTerritory(territorySlug, signal),
    retry: false,
    refetchOnWindowFocus: false,
    enabled: territorySlug !== undefined,
  });
};

export const useTerritoryConfig = (territorySlug: string, vehicleId: number | undefined) => {
  return useQuery({
    queryKey: ['territory-config', territorySlug],
    queryFn: ({ signal }) => getConfiguration(territorySlug, vehicleId, signal),
    retry: false,
    enabled: vehicleId !== undefined,
  });
};
